import { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import API_URL from '../config/ApiUrl';
export const useVideoChat = (roomId, username) => {
  const [socket, setSocket] = useState(null);
  const [isInRoom, setIsInRoom] = useState(false);
  const [roomUsers, setRoomUsers] = useState([]);
  const [remoteStreams, setRemoteStreams] = useState({});
  const [connectionStatus, setConnectionStatus] = useState('Disconnected');

  const localVideoRef = useRef(null);
  const localStreamRef = useRef(null);
  const peerConnectionsRef = useRef({});

  const [servers, setServers] = useState({
    iceServers: [
      { urls: 'stun:stun.l.google.com:19302' } // Fallback
    ]
  });

  // Add this useEffect to get Twilio TURN servers
  useEffect(() => {
    const getTurnServers = async () => {
      try {
        const response = await fetch(`${API_URL}/api/turn-credentials`, {
          method: 'POST',
          credentials: 'include'
        });
        const data = await response.json();
        
        console.log('🎯 Got Twilio TURN servers:', data.iceServers);
        setServers({ iceServers: data.iceServers });
      } catch (error) {
        console.error('❌ Failed to get TURN servers:', error);
      }
    };
    
    getTurnServers();
  }, []);
  const shouldCall = (myId, theirId) => myId < theirId;

  const forceReconnectToPeer = async (targetUserId) => {
    console.log(`🔄 FORCING RECONNECT to ${targetUserId}`);
    
    // Close existing connection
    if (peerConnectionsRef.current[targetUserId]) {
      peerConnectionsRef.current[targetUserId].close();
      delete peerConnectionsRef.current[targetUserId];
    }
    
    // Remove from remote streams
    setRemoteStreams(prev => {
      const updated = { ...prev };
      delete updated[targetUserId];
      return updated;
    });
    
    // Wait a moment then reconnect
    setTimeout(() => {
      if (localStreamRef.current && shouldCall(socket.id, targetUserId)) {
        initiateCallToUser(targetUserId);
      }
    }, 1000);
  };

  // EXACT COPY from your working code
  const createPeerConnection = (remoteUserId) => {
    console.log(`🔗 Creating peer connection for user: ${remoteUserId}`);
    
    const pc = new RTCPeerConnection(servers);

    // Add local stream
    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(track => {
        console.log(`➕ Adding ${track.kind} track for ${remoteUserId}`);
        pc.addTrack(track, localStreamRef.current);
      });
    }

    // Handle remote stream
    pc.ontrack = (event) => {
      console.log(`🎉 Received remote stream from ${remoteUserId}`);
      console.log('📊 Stream details:', {
        streamId: event.streams[0].id,
        trackCount: event.streams[0].getTracks().length,
        videoTracks: event.streams[0].getVideoTracks().length,
        audioTracks: event.streams[0].getAudioTracks().length
      });
      
      setRemoteStreams(prev => {
        const updated = {
          ...prev,
          [remoteUserId]: event.streams[0]
        };
        console.log('📊 Updated remote streams:', Object.keys(updated));
        console.log('📊 All stream users:', Object.keys(updated).map(id => id.slice(-4)));
        return updated;
      });
    };

    pc.onicecandidate = (event) => {
      console.log('==================================================================');
      console.log('=event=', event);
      console.log('==================================================================');
      if (event.candidate) {
        // ADD THIS DEBUG LINE:
        console.log(`🧊 ICE candidate TYPE: ${event.candidate.type} for ${remoteUserId}`);
        console.log(`🧊 ICE candidate details:`, event.candidate.candidate);
        
        if (socket && socket.connected) {
          socket.emit('webrtc-message', {
            type: 'ice-candidate',
            candidate: event.candidate,
            roomId: roomId,
            targetUser: remoteUserId
          });
        }
      } else {
        console.log(`🧊 ICE gathering complete for ${remoteUserId}`);
      }
    };

    // Connection state monitoring
    pc.onconnectionstatechange = () => {
      console.log(`Connection with ${remoteUserId}:`, pc.connectionState);
    };
    
    pc.oniceconnectionstatechange = () => {
      console.log(`🧊 ICE connection with ${remoteUserId}:`, pc.iceConnectionState);
      
      // ADD THIS DEBUG:
      if (pc.iceConnectionState === 'failed') {
        console.log(`❌ ICE FAILED - trying to get connection stats`);
        pc.getStats().then(stats => {
          stats.forEach(report => {
            if (report.type === 'candidate-pair') {
              console.log(`ICE candidate pair:`, report);
            }
          });
        });
      }
    };
    pc.onicegatheringstatechange = () => {
      console.log(`ICE gathering state for ${remoteUserId}:`, pc.iceGatheringState);
    };


  };

  const initiateCallToUser = async (targetUserId) => {
    console.log(`📞 Initiating call to ${targetUserId}`);
          console.log('IN THE VIDEuseSesh RoomO CHAT')

    console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
    console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
    console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
    console.log('THIS IS WHERE CLAUDE THINKS ISSUES ARE')
    if (!socket || !socket.connected) {
    console.log('❌ Socket not ready, waiting...');
    setTimeout(() => initiateCallToUser(targetUserId), 1000);
    return;
  }
    console.log(peerConnectionsRef.current)
    if (peerConnectionsRef.current[targetUserId]) {
      console.log(`⏭️ Already have peer connection for ${targetUserId}`);
      console.log('CLAUDE THINK THIS SHOULD BE A RETURN ')
      return;
    }
    console.log(`📞 Initiating call to ${targetUserId}`);

    try {
      console.log('ABOUT TO CREATE THE PEER CONECTION')
      const pc = createPeerConnection(targetUserId);
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);
      
      if (socket && socket.connected) {
        console.log('SOCKET CONNECTED COMMITED EMIT OFFER')
        socket.emit('webrtc-message', {
          type: 'offer',
          offer: offer,
          roomId: roomId,
          targetUser: targetUserId
        });
        console.log(`📤 Sent offer to ${targetUserId}`);
      } else {
        console.error('❌ Socket not available to send offer');
      }
    } catch (error) {
      console.error('❌ Error initiating call:', error);
    }
  };

  // EXACT COPY of your WebRTC message handler
  const handleWebRTCMessage = async (data) => {
    console.log('IN THE USE SESH ROOLM ')
    console.log('==================================================================');
    console.log('=WEBRTC MESSAGE RECEIVED=', data.type);
    console.log('=FROM=', data.from);
    console.log('=HAS ICE CANDIDATE=', !!data.candidate);
    if (data.candidate) {
      console.log('=RECEIVED CANDIDATE TYPE=', data.candidate.type);
    }
    console.log('==================================================================');
    const { type, from } = data;
      const timestamp = Date.now();

    console.log(`📨 Handling ${type} from ${from} at ${timestamp}`);

    try {
      if (type === 'offer') {
        console.log('🔄 Processing offer...');
 
        const pc = createPeerConnection(from);
        await pc.setRemoteDescription(new RTCSessionDescription(data.offer));
        console.log('✅ Remote description set for offer');
        console.log(`[${from}] Remote description set in ${Date.now() - timestamp}ms`);

        const answer = await pc.createAnswer();
        await pc.setLocalDescription(answer);
        console.log(`[${from}] Answer created and set in ${Date.now() - timestamp}ms`);

        console.log('✅ Local description set for answer');
        
        if (socket && socket.connected) {
          socket.emit('webrtc-message', {
            type: 'answer',
            answer: answer,
            roomId: roomId,
            targetUser: from
          });
          console.log(`📤 Sent answer to ${from}`);
        }
        
      } else if (type === 'answer') {
        console.log('🔄 Processing answer...');
        const pc = peerConnectionsRef.current[from];
        if (pc) {
          await pc.setRemoteDescription(new RTCSessionDescription(data.answer));
          console.log(`✅ Answer processed from ${from}`);
        }
        
      } else if (type === 'ice-candidate') {
        console.log('🔄 Processing ICE candidate...');
        const pc = peerConnectionsRef.current[from];
        if (pc && data.candidate) {
          await pc.addIceCandidate(new RTCIceCandidate(data.candidate));
          console.log(`✅ ICE candidate added from ${from}`);
        }
      }
    } catch (error) {
      console.error(`❌ Error handling ${type}:`, error);
    }
  };

  // EXACT COPY of your media stream getter with fallback
  const getMediaStream = async () => {
    try {
      console.log('📹 Trying camera...');
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { width: 640, height: 480 }, 
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true
        }
      });
      console.log('📹 Got camera media');
      return stream;
    } catch (cameraError) {
      console.log('❌ Camera failed, trying screen share...', cameraError.message);
      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({ 
          video: true, 
          audio: true 
        });
        console.log('🖥️ Got screen share media');
        return stream;
      } catch (screenError) {
        console.error('❌ Both camera and screen share failed:', screenError);
        throw screenError;
      }
    }
  };

  useEffect(() => {
    if (!roomId) return;

    console.log('🚀 Initializing VideoChat');
    
    const newSocket = io(`${API_URL}`, {
      withCredentials: true
    });
    setSocket(newSocket);

    // Get media stream on initialization (EXACT COPY from your working code)
    getMediaStream()
    .then(stream => {
      localStreamRef.current = stream;
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
      }
      setConnectionStatus('Ready');
    })
    .catch(error => {
      console.error('❌ Media error:', error);
      setConnectionStatus('Media Error - Click to Share Screen');
    });

    // Socket event listeners (EXACT COPY)
    newSocket.on('connect', () => {
      console.log('🔌 Connected to server');
      setConnectionStatus('Connected');
    });

    newSocket.on('disconnect', () => {
      console.log('🔌 Disconnected');
      setConnectionStatus('Disconnected');
      setIsInRoom(false);
    });

    newSocket.on('room-info', (data) => {
      console.log('🏠 Room info:', data);
      setRoomUsers(data.users);
      setIsInRoom(true);
      
      // Auto-call existing users when we join (EXACT COPY)
      setTimeout(() => {
        data.users.forEach(userId => {
          if (
            userId !== newSocket.id && 
            localStreamRef.current &&
            shouldCall(newSocket.id, userId)
          ) {
            console.log(`🚀 Auto-calling existing user: ${userId}`);
            initiateCallToUser(userId);
          }
        });
      }, 2000);
    });

    newSocket.on('user-joined', (data) => {
      console.log('👋 User joined:', data.userId);
      
      setRoomUsers(prev => {
        const updated = [...prev.filter(id => id !== data.userId), data.userId];
        console.log('👥 Updated room users:', updated);
        return updated;
      });
      
      // Automatically initiate call to new user (EXACT COPY)
      setTimeout(() => {
        console.log('⏰ Auto-call timeout triggered');
        
        if (
          localStreamRef.current &&
          newSocket &&
          shouldCall(newSocket.id, data.userId)
        ) {
          initiateCallToUser(data.userId);
        }
      }, 3000);
    });

    newSocket.on('user-left', (data) => {
      console.log('👋 User left:', data.userId);
      setRoomUsers(prev => prev.filter(id => id !== data.userId));
      
      // Clean up peer connection (EXACT COPY)
      if (peerConnectionsRef.current[data.userId]) {
        peerConnectionsRef.current[data.userId].close();
        delete peerConnectionsRef.current[data.userId];
      }
      
      // Remove remote stream
      setRemoteStreams(prev => {
        const newStreams = { ...prev };
        delete newStreams[data.userId];
        return newStreams;
      });
    });

    newSocket.on('webrtc-message', handleWebRTCMessage);

    return () => {
      console.log('🧹 Cleanup');
      if (localStreamRef.current) {
        localStreamRef.current.getTracks().forEach(track => track.stop());
      }
      Object.values(peerConnectionsRef.current).forEach(pc => pc.close());
      newSocket.disconnect();
    };
  }, [roomId]);

  // EXACT COPY of your screen share function
  const startScreenShare = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({ 
        video: true, 
        audio: true 
      });
      
      localStreamRef.current = stream;
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
      }
      setConnectionStatus('Ready');
      
      // Update existing peer connections with new stream (EXACT COPY)
      Object.values(peerConnectionsRef.current).forEach(pc => {
        const senders = pc.getSenders();
        stream.getTracks().forEach(track => {
          const sender = senders.find(s => s.track && s.track.kind === track.kind);
          if (sender) {
            sender.replaceTrack(track);
          }
        });
      });
      
      console.log('🖥️ Screen share started');
      return true;
    } catch (error) {
      console.error('❌ Screen share failed:', error);
      return false;
    }
  };

  const joinRoom = () => {
    if (socket && roomId) {
      console.log(`🚪 Joining room: ${roomId}`);
      socket.emit('join-room', { roomId: roomId });
    }
  };

  // EXACT COPY of your callAllUsers function
  const callAllUsers = () => {
    console.log('📞 Calling all users in room');
    roomUsers.forEach(userId => {
      if (
        userId !== socket?.id && 
        !remoteStreams[userId] &&
        shouldCall(socket.id, userId)
      ) {
        console.log(`📞 Calling user: ${userId}`);
        setTimeout(() => initiateCallToUser(userId), 500);
      }
    });
  };

  return {
    // State
    socket,
    isInRoom,
    roomUsers,
    remoteStreams,
    connectionStatus,
    localVideoRef,
    localStreamRef,
    peerConnectionsRef,
    forceReconnectToPeer,
    // Actions - EXACT same functionality as your working VideoChat
    joinRoom,
    startScreenShare,
    callAllUsers,
    
    // Computed
    localStream: localStreamRef.current,
    hasLocalStream: !!localStreamRef.current,
    remoteStreamCount: Object.keys(remoteStreams).length
  };
};